export const LangKeys: string[] = ['id']

export const standardCountryLanguageCodes: { [key: string]: string } = {
    'id': 'id-ID',
}